/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useRef } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

const Input = ({
  type = 'text',
  value,
  maxLength,
  onChange,
  onBlur,
  label,
  error,
  errorText,
  tooltipText,
  ...props
}) => {
  const ref = useRef();
  const [isFocus, setIsFocus] = useState(false);

  return (
    <>
      <div className={`input-field ${error ? 'error' : ''}`}>
        <input
          className={cn({ error })}
          ref={ref}
          autoComplete="off"
          value={value}
          type={type}
          maxLength={maxLength}
          onChange={({ target }) => onChange(target.value)}
          onFocus={() => setIsFocus(true)}
          onBlur={() => {
            setIsFocus(false);
            onBlur();
          }}
          {...props}
        />
        {label && (
          <label
            onClick={() => ref.current.focus()}
            className={cn({ active: value !== '' || isFocus })}
          >
            {label}
          </label>
        )}
        {tooltipText && isFocus && <div className="tooltipHInfo-text tooltipH">{tooltipText}</div>}
      </div>
      {error && (
        <span className="show-error">{errorText}</span>
      )}
    </>
  );
};

Input.defaultProps = {
  type: 'text',
  maxLength: '',
  onBlur: () => { },
  label: '',
  error: false,
  errorText: '',
  activeRef: false,
  tooltipText: '',
};

Input.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string.isRequired,
  maxLength: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  label: PropTypes.string,
  error: PropTypes.string,
  errorText: PropTypes.string,
  activeRef: PropTypes.bool,
  tooltipText: PropTypes.string,
};

export default Input;
